import { registerCascades } from "tsi-common-react/src/apps/retail/cascades";

import { store } from "../../store";

// Register store cascades. The retail-locator app itself now renders inside the
// reactivated document tree (via the StoreLocatorForm block) rather than being
// mounted by a dynamicPlaceComponent scanner; this residual module keeps the
// load-bearing cascade registration, which must run once at client entry.
registerCascades(store, {
    has_slot_sealy: "Y",
    distance: 50,
});
